import CentumInput from 'components/MainPage/dcs/centumvp/components/Input/CentumInput';
import { event } from 'jquery';
import React, { useState } from 'react';
import { tabComponents } from '../SearchCondition';
import { Config } from '../searchConditionInterface';

interface IMessageType {
    messageType: {};
}

const MessageTypeComponent: React.FC<tabComponents> = (props) => {
    const styleInputs = { display: 'flex', alignItems: 'center', marginBottom: '10px' };

    const messageType = props.tempConfig.messageType;
    const displayEnabled = props.tempConfig.display.search;
    const specifyNumber = props.tempConfig.messageType.specifyNumber;
    const specifyMessageType = props.tempConfig.messageType.specifyMessageType;

    function capitalizeFirstLetter(string: string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    const radioOptions = Object.entries(props.tempConfig.messageType.specifyMessageType.types).map(([key, value]) => {
        const label =
            capitalizeFirstLetter(key)
                .match(/[A-Z][a-z]+/g)
                ?.join(' ') || '';

        return {
            id: key,
            label: label,
            checked: value,
            displayEnabled: displayEnabled && specifyMessageType.state,
            onchange: (id: any, value: any) => {
                SetType(id, value);
            }
        };
    });

    const SetType = (id: any, value: any) => {
        const updateConf = { ...props.tempConfig };
        updateConf.messageType.specifyMessageType.setType(id, value);
        props.SaveConfig(updateConf);
    };

    const SetNumber = (id: any, value: any) => {
        const updateConf = { ...props.tempConfig };
        updateConf.messageType.specifyNumber.messageNo[id] = value;
        props.SaveConfig(updateConf);
    };

    const SelectType = (mode: string) => {
        const updateConf = { ...props.tempConfig };
        updateConf.messageType.select(mode);
        props.SaveConfig(updateConf);
    };

    const renderCheckboxes = (
        options: {
            id: string;
            label: string;
            checked: boolean;
            displayEnabled: boolean;
            onchange?: (id: any, value: any) => void;
        }[]
    ) =>
        options.map((option) => (
            <div key={option.id} style={styleInputs}>
                <CentumInput
                    id={option.id}
                    type="checkbox"
                    checked={option.checked}
                    enable={option.displayEnabled}
                    onChange={(id: any, value: any) => {
                        if (option.onchange) option.onchange(id, value);
                    }}
                />
                <div>{option.label}</div>
            </div>
        ));

    return (
        <div
            style={{
                boxSizing: 'border-box',
                width: '100%',
                padding: '20px',
                fontSize: '12px',
                color: displayEnabled ? 'black' : '#808080',
                pointerEvents: displayEnabled ? 'auto' : 'none'
            }}>
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                <CentumInput
                    enable={!displayEnabled}
                    checked={messageType.all}
                    type="radio"
                    id="All"
                    onChange={() => SelectType('all')}
                />
                <span>All</span>
            </div>
            <div>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <CentumInput
                        enable={!displayEnabled}
                        checked={messageType.specifyMessageType.state}
                        type="radio"
                        id="SpecifyMessageType"
                        onChange={() => SelectType('specifyMessageType')}
                    />
                    <span>Specify Message Type</span>
                </div>
                <div style={{ display: 'flex', padding: '10px' }}>
                    <div>{renderCheckboxes(radioOptions.slice(0, 4))}</div>
                    <div>{renderCheckboxes(radioOptions.slice(4))}</div>
                </div>
            </div>
            <div>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <CentumInput
                        enable={!displayEnabled}
                        checked={messageType.specifyNumber.state}
                        type="radio"
                        id="SpecifyNumber"
                        onChange={() => SelectType('specifyNumber')}
                    />
                    <span>Specify Number ( "" OK)</span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '5px', padding: '5px 30px' }}>
                    <div>Message No</div>
                    {specifyNumber.messageNo.map((num, index) => (
                        <CentumInput
                            enable={specifyNumber.state && displayEnabled}
                            value={num}
                            key={index}
                            id={index.toString()}
                            type="text"
                            width={30}
                            height={20}
                            onChange={SetNumber}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default MessageTypeComponent;
